import React, { useState } from "react";
import { Link } from "react-router-dom";

export default function ArticlesItem({
  id,
  title,
  category,
  tags,
  position,
  changeStatus,
  enabled,
  date,
  author,
  tagToSearch
}) 

{

    const [showText, setshowText] = useState(false)

    const showTextF = () => {
        setshowText(!showText)
        setTimeout(() => {
            setshowText(false)
        }, 2000);
    }
    const changeStatusF = () => {
        changeStatus(id, enabled)
    }
  return (
    <div className="admin-article-item">
      <p className="admin-article-item-title red-and-bold">{title}</p>
      <p className="admin-article-item-category">{category}</p>

      <p className="admin-article-item-position">{position}</p>
      <p className="admin-article-item-nameydate"> {author} </p>
      {/* <p className="admin-article-item-nameydate"> {date} </p> */}
      <p className="admin-article-item-tags">
        {" "}
        {tags.map((tag) => (
          <button onClick={() => {
            tagToSearch(tag)
          }} className="admin-article-item-tag tag-hover">{tag}</button>
        ))}{" "}
      </p>

      <div className="admin-article-item-button-row position-relative">

      {showText ? 
      <button  className="buttonbyn buttonbyn-color-invert">
       {enabled ? "OCULTAR" : "MOSTRAR"}
      </button>
      : 

<Link onClick={() => {
            window.scrollTo(0, 0)
          }} to={`/adm/edit/${id}`} className="buttonbyn">
EDITAR
</Link>
       }

 

        {enabled ? (
           
                      <img
                      className="admin-article-item-enabled-toggle"
            onClick={changeStatusF} onMouseEnter={showTextF} onMouseLeave={showTextF}

            src="https://img.icons8.com/material-sharp/48/008000/visible.png"
            alt="hide"
          />
      
           

        ) : (
          <img
            onClick={changeStatusF} onMouseEnter={showTextF} onMouseLeave={showTextF}
             className="admin-article-item-enabled-toggle"
         
            src="https://img.icons8.com/material-sharp/48/ca4343/hide.png"
            alt="hide"
          />
        )}


      
      </div>

    </div>
  );
}
